import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import TemplateFieldMappingForm from '@shared/TemplateFieldMappingForm'

const Content = ({ user }) => {
  const navigate = useNavigate()

  const handleSave = () => {
    navigate('/datalogic/template-settings#template-field-mappings')

    Swal.fire({
      text: 'Field mapping added!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })
  }

  return (
    <Fragment>

      <Title text='New Template Field Mapping' user={user}/>

      <TemplateFieldMappingForm
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const NewTemplateFieldMapping = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default NewTemplateFieldMapping
